import { useContext } from "react";
import { SideBarContext } from "./SideBar";
import "./SideBarLabelGroup.css";

export default function SideBarLabelGroup({ label, children }) {
  const { isExpanded } = useContext(SideBarContext);

  return (
    <li className="sidebar-section">
      {isExpanded ? (
        <span className="sidebar-label">{label}</span>
      ) : (
        <hr className="sidebar-separator" />
      )}
      <ul className="sidebar-section-items">{children}</ul>
    </li>
  );
}